import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaEnvelope,FaBars,FaTimes} from "react-icons/fa";
import { useState } from 'react';
import Navbar from './Navbar';


const AboutUs = () => {
      const [menuOpen, setMenuOpen] = useState(false);
  return (<>
 <Navbar/>
    <div className="w-full mt-12 flex flex-col md:flex-row items-center justify-between px-4">
            
      {/* Image Section */}
      <img
        src="https://www.quranicconnection.tv/wp-content/uploads/2019/02/UnderstandQuran.jpg"
        alt="Mission Image"
        className="w-full md:w-1/2 h-auto max-h-[400px] object-cover rounded-lg"
      />

      {/* Text Section */}
      <div className="md:w-1/2 p-6 md:p-8 text-center md:text-left">
        <h2 className="text-2xl md:text-4xl font-serif text-blue-700 mb-2">
          More About Our Mission
        </h2>
        <div className="w-24 md:w-[450px] h-1 bg-blue-700 mx-auto md:mx-0 mb-4"></div>

        {/* Content */}
        <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-6">
          <span className="font-semibold">The Quran Explained</span> is a groundbreaking initiative—a single-volume commentary of the Qur'an in English, filling a critical gap in Islamic scholarship. This work aims to make the deeper meanings of the Qur'an accessible to all Muslims worldwide, providing a valuable resource for madrassas, Islamic schools, community centers, and households.
        </p>

        <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-6">
          The project is led by <span className="font-semibold">Alexander Khaleeli</span>, an experienced scholar and translator with over 15 years of expertise. Having studied in the traditional Islamic seminary (Hawza) and pursued PhD research at the University of Exeter, he brings a unique combination of classical and academic scholarship. His notable translations include works such as <i>Muniyat al-Murid</i> and <i>Tafsir al-Asfa</i>.
        </p>

        <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-6">
          Validated by respected scholars, this project aims to bridge the gap between traditional knowledge and modern accessibility. The commentary will be available in both print and digital formats, with plans to integrate it into an AI-enhanced app for wider reach.
        </p>

        <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-6">
          Progress So Far:Nearly one-third of the translation has been completed, covering 170 pages (up to the 9th Juz). The first volume is set to be completed by Ramadhan 2025, with the full commentary expected by Ramadhan 2026.
        </p>

        <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-6">
          To achieve this, we seek to raise £8,500 to finalize the first volume and £35,000 for the entire project. These funds will cover translation, editing, typesetting, and design to ensure the highest quality publication.
        </p>

        <p className="text-gray-700 text-sm md:text-base leading-relaxed">
          This is a unique opportunity to support a vital Islamic initiative, making the teachings of the Qur'an more accessible to English-speaking audiences worldwide.
        </p>
      </div>
    </div>
     <footer className="w-full mt-12 p-6 bg-gray-900 text-white text-center transition duration-300 hover:bg-gray-800">
                   <p className="text-sm">© 2025 The Quraniverse.ai. All Rights Reserved.</p>
                   <div className="flex justify-center space-x-6 mt-4">
                     <a href="https://www.facebook.com/profile.php?id=61573829216416" target="_blank" rel="noopener noreferrer" className="text-white text-2xl hover:text-gray-400"><FaFacebookF /></a>
                     <a href="https://www.instagram.com/quraniverse_ai?igsh=MWo3c2trbXVodnhpbA==" target="_blank" rel="noopener noreferrer" className="text-white text-2xl hover:text-gray-400"><FaInstagram /></a>
                     <a href="mailto:info@quraniverse.ai" className="text-white text-2xl hover:text-gray-400"><FaEnvelope /></a>
                   </div>
                 </footer>
    </>
  );
};

export default AboutUs;
